<template>
    <div class="tab-param" >
     
        <center v-if="l2dlist.length<=0"><img src="@/assets/images/null.png"/></center>
        <div class="content-box h5_height">
            <ul class="t9" style="background-color:#fff" v-if="l2dlist.length>0">
                <li v-for="(item,i) in l2dlist" :key="i+'v2c'" >

                <div class="t9_title">
                    <div class="t9_title_top">
                        <i></i><span class="t9_title_title" style="overflow:hidden">{{item.text?item.text:'未命名'}}（{{item.live2did}}）</span>
                    </div>
                </div>
                <div style="padding:0 15px">
                     <vue-slider v-model="item.normal" :title="item.min+':'+item.max" :min="item.min" :max="item.max" @change="updateParam(item.live2did,item.normal)" :process-style="{ backgroundColor: 'pink' }" />
                </div>

                
            </li>
            
            </ul>
        </div>            
    </div>
</template>

<script>

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
export default {
    name: 'Action',
    props:['modelClass','user'],
    components:{
   
        VueSlider
      
    },
    data(){
        return {
            t9live2d:[],//模型参数
            t9parm:[],//t9参数
            l2dlist:[],//整合后的集合
            playTimer:0,//计时器
            action:[]//动画列表
        }
    },
    created(){
       
        
        this.gett9Param();
    },

    methods:{

       //修改参数
       updateParam(key,value){

           this.modelClass.updateLive2dParam(key,value);
       },

       // 获取输入参数
        gett9Param(){
            

           
            //获取模型参数(已绑定的参数禁用)
            var l2dlist =this.modelClass.getModelParam()

            // 输出参数去除掉模型不存在的参数
            l2dlist.forEach((item,index)=>{
                item.min=parseInt(item.min);
                item.max=parseInt(item.max);
            })

            this.l2dlist = l2dlist;

        },
    },
   
}
</script>
<style lang="scss" scoped>
.tab_bg .tab_input {
    bottom: -36px;
}
</style>